import React from "react";
import { useParams } from "react-router";
import { AddTransactionWizard } from "./AddTransactionWizard";

export const AddTransactionWizardWithRouting = () => {
  const { id } = useParams<"id">();

  return <AddTransactionWizard investmentId={Number.parseInt(id!)} />;
};
